module.exports = {"title":"Password","description":"Please enter your password to unlock the Presale.","submit":"Submit"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/PasswordModal/locales/en.json
// module id = 1332
// module chunks = 0